import { Amount, BondPriceNominal, Currency, OrderTicketId } from "@goodfill/domain-properties";
import {
  AccruedInterestAmountComponent,
  BondPriceComponent,
  FaceAmountComponent,
  SettlementAmountComponent,
  SettlementDateComponent,
  TradeDateComponent,
  TransactionCostAmountComponent,
  TransactionRateUpfrontComponent,
} from "@goodfill/domain-properties-components";
import { Field, Flex } from "@goodfill/ui-components";
import Decimal from "decimal.js";
import { DateTime } from "luxon";
import { InfoTooltip } from "../../../../ui-components/tooltip/InfoTooltip";
import { orderFilters } from "../../../account/portfolio/orderList/OrderTicketFilter";
import { Info } from "../../../Info";
import "./commonFormStyles.scss";
import "./CreateOrderStatistics.scss";
import { TIMEZONE_NEY_YORK } from "../../../../locale/timezone";

export interface CreateOrderStatisticsProps {
  currency: Currency;
  accruedInterest: Amount | null;
  actualInvestment?: Amount;
  settlementValue: Amount | null;
  settlementDate?: DateTime | null;
  tradeDate: DateTime | null;
  transactionCostAmount: Amount | null;
  transactionCostRateUpfront: Decimal | null;
  prevailingMarketPrice: BondPriceNominal;
  orderId?: OrderTicketId;
  showCalculatedInfo: boolean;
}

export const CreateOrderStatistics = (props: CreateOrderStatisticsProps) => {
  return (
    <div className="flex flex-col gap-2 info-details-container px-4 py-6 sm:px-8">
      <div className="order-stats-container">
        {props.showCalculatedInfo ? (
          <>
            <Info label="Trade Date" className="flex info-details  ">
              {props.tradeDate !== null ? (
                <TradeDateComponent value={props.tradeDate} timezone={TIMEZONE_NEY_YORK} />
              ) : (
                "On or before expiration date"
              )}
            </Info>
            <Info label="Settlement Date" className="flex info-details ">
              {props.settlementDate != null ? (
                <SettlementDateComponent value={props.settlementDate} timezone={TIMEZONE_NEY_YORK} />
              ) : (
                "2 days after the trade date"
              )}
            </Info>
            <Info label="Transaction cost rate upfront" className="flex info-details ">
              {props.transactionCostRateUpfront !== null ? (
                <TransactionRateUpfrontComponent value={props.transactionCostRateUpfront} />
              ) : null}
            </Info>
            <Info label="Transaction cost Amount" className="flex info-details ">
              {props.transactionCostAmount !== null ? (
                <TransactionCostAmountComponent value={props.transactionCostAmount} />
              ) : null}
            </Info>
          </>
        ) : (
          <Info label="" justify="end" />
        )}
      </div>

      <div className="flex w-full">
        <div className="order-stats-container">
          <div>
            <Field
              label={
                <>
                  Actual Investment <InfoTooltip text="Actual Investment = Order Price Post-Fee (%) x Face Amount." />
                </>
              }
              textAlign="left"
              labelClassName="flex-col md:flex-row  justify-between gap-5 md:gap-9      mt-1 md:mt-2"
              valueClassName="CreateOrderStatistics_statsValues CreateOrderStatistics_statsValues980to670"
            >
              <Flex direction="row" justify="between">
                <div className="info-details-fonts ">
                  {props.actualInvestment && <FaceAmountComponent value={props.actualInvestment} />}
                </div>
                <div className="text-center w-full info-details-fonts plus-on-sm">+</div>
              </Flex>
            </Field>
          </div>
          <div className={`${props.orderId === null && "items-center"} flex  flex-row`}>
            <Info
              label="Accrued Interest"
              className="flex info-details accrued-interest"
              marginTopCustom="CreateOrderStatistics_statsValues"
            >
              {props.accruedInterest !== null ? (
                <AccruedInterestAmountComponent value={props.accruedInterest} />
              ) : (
                "To Be Determined"
              )}
            </Info>
            <div className="text-center w-full info-details-fonts mt-9 equals-on-sm CreateOrderStatistics_equalCustomMargin">
              =
            </div>
          </div>
          <Field
            label={
              <>
                Settlement Proceeds
                <InfoTooltip text="Settlement Proceeds = Actual Investment + Accrued Interest. " />
              </>
            }
            textAlign="left"
            valueClassName="CreateOrderStatistics_statsValues CreateOrderStatistics_statsValues980to670"
            labelClassName="flex-col md:flex-row  justify-between gap-5 md:gap-9      mt-1 md:mt-2"
          >
            <Flex direction="row">
              <div className="info-details-fonts">
                {props.settlementValue != null ? (
                  <SettlementAmountComponent value={props.settlementValue} />
                ) : (
                  "To Be Determined"
                )}
              </div>
            </Flex>
          </Field>
          {props.orderId != null ? (
            <Info label="ID" className="flex info-details ">
              <>{props.orderId}</>
            </Info>
          ) : (
            <Info label="Prevailing Market Price" className="flex info-details">
              <BondPriceComponent value={props.prevailingMarketPrice} />
            </Info>
          )}
        </div>
      </div>
    </div>
  );
};
